import { Button, Modal, Select } from 'antd';
import React, { useState } from 'react';
import { EntityType } from '../../types.generated';
import { useEntityRegistry } from '../useEntityRegistry';
import { useTranslation } from '../../i18n/useTranslation';

type Props = {
    onCloseModal: () => void;
    onOk?: (results: string[]) => void;
    title?: string;
    defaultValues?: string[];
};

const { Option } = Select;

export const ChooseEntityTypeModal = ({ defaultValues, onCloseModal, onOk, title }: Props) => {
    const { t } = useTranslation();
    const entityRegistry = useEntityRegistry();
    const entityTypes = entityRegistry.getSearchEntityTypes();

    const [stagedValues, setStagedValues] = useState(defaultValues || []);

    const addEntityType = (newType) => {
        setStagedValues([...stagedValues, newType]);
    };

    const removeEntityType = (type) => {
        setStagedValues(stagedValues.filter((stagedValue) => stagedValue !== type));
    };

    return (
        <Modal
            visible
            centered
            keyboard
            title={title}
            className="f-modal"
            onCancel={onCloseModal}
            footer={
                <>
                    <Button onClick={onCloseModal} type="default">
                        {t('Cancel')}
                    </Button>
                    <Button disabled={stagedValues.length === 0} onClick={() => onOk?.(stagedValues)} type="primary">
                        {t('Done')}
                    </Button>
                </>
            }
        >
            <Select
                showArrow
                mode="multiple"
                style={{ width: '100%' }}
                aria-label={t('Choose Entity Type')}
                dropdownMatchSelectWidth={false}
                onSelect={(newValue) => addEntityType(newValue)}
                onDeselect={(newValue) => removeEntityType(newValue)}
                placeholder={t('Datasets, Charts and More')}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                value={stagedValues.map((stagedEntityType) => ({
                    value: stagedEntityType,
                    label: entityRegistry.getCollectionName(stagedEntityType as EntityType),
                }))}
            >
                {entityTypes.map((type) => (
                    <Option key={type} value={type} tabIndex={0}>
                        {entityRegistry.getCollectionName(type)}
                    </Option>
                ))}
            </Select>
        </Modal>
    );
};
